export class LoginModel {
    email: string;
    password: string;
    incorrect: boolean;
    message: string;
}
